import script from "./CreateTask.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateTask.vue?vue&type=script&setup=true&lang=ts"

import "./CreateTask.vue?vue&type=style&index=0&id=cbb53480&lang=scss"

const __exports__ = script;

export default __exports__